import { MessageTemplateStatus } from '../models/MessageTemplateStatus';
import { MessageTemplateRejectedReasonStatus } from '../models/MessageTemplateRejectedReasonStatus';
import { MessageTemplateFeatures } from '../MessageTemplateFeatures';
import './DetailsMessageTemplateSidebar.scss';
import { MessageTemplateButtonTypes } from '../models/MessageTemplateButtons';
export class DetailsMessageTemplateSidebarController {
    static $inject = ['$document', 'close', '$scope', '$timeout', 'data', 'elementId', 'BlipToastService', '$translate', 'LoadingService', 'MessageTemplateService', 'MessageTemplateSegmentService', 'clipboard', 'onDeleteMessageTemplate', 'onDuplicateMessageTemplate', 'AlertService'];
    constructor($document, close, $scope, $timeout, data, elementId, BlipToastService, $translate, LoadingService, MessageTemplateService, MessageTemplateSegmentService, clipboard, onDeleteMessageTemplate, onDuplicateMessageTemplate, AlertService) {
        'ngInject';
        this.$document = $document;
        this.close = close;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.data = data;
        this.elementId = elementId;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.LoadingService = LoadingService;
        this.MessageTemplateService = MessageTemplateService;
        this.MessageTemplateSegmentService = MessageTemplateSegmentService;
        this.clipboard = clipboard;
        this.onDeleteMessageTemplate = onDeleteMessageTemplate;
        this.onDuplicateMessageTemplate = onDuplicateMessageTemplate;
        this.AlertService = AlertService;
        this.initialize();
        this.$scope.$on('$destroy', this.$onDestroy.bind(this));
        this.checkFeatures();
    }
    $onDestroy() {
        if (this._boundSetSidebarHeight) {
            window.removeEventListener('scroll', this._boundSetSidebarHeight);
            window.removeEventListener('resize', this._boundSetSidebarHeight);
            this._boundSetSidebarHeight = null;
        }
    }
    async checkFeatures() {
        this.isNewestMessageTemplateCategoriesEnabled = await MessageTemplateFeatures.isNewestMesssageTemplateCategoriesEnabled();
        this.isMetaBiddingAlphaEnabled = await MessageTemplateFeatures.isMetaBiddingAlphaEnabled();
    }
    async initialize() {
        this.data.showCategory = await this.$translate('messageTemplate.categories.' + this.data.category);
        this.data.namespace = await this.getWabaNamespace();
        this.verifyButtonType();
        // store bound handler so it can be removed on destroy
        this._boundSetSidebarHeight = this.setSidebarHeight.bind(this);
        window.addEventListener('scroll', this._boundSetSidebarHeight);
        window.addEventListener('resize', this._boundSetSidebarHeight);
        this.setSidebarHeight();
    }
    formatMetaBidDisplay(translation) {
        if (translation.bidSpec?.bidAmount) {
            const valueInReais = translation.bidSpec.bidAmount / 100;
            return valueInReais.toFixed(2).replace('.', ',');
        }
        return '';
    }
    isMarketingCategorySelected() {
        return this.data.category === 'MARKETING';
    }
    shouldShowMetaPricing(translation) {
        return (this.isMetaBiddingAlphaEnabled &&
            this.isMarketingCategorySelected() &&
            translation.bidSpec?.bidAmount > 0);
    }
    async getWabaNamespace() {
        try {
            const wabaInformation = await this.MessageTemplateService.getWABAInformation();
            if (wabaInformation) {
                return wabaInformation.message_template_namespace;
            }
        }
        catch (error) {
            const errorTitle = await this.$translate('detailsMessageTemplateSidebar.toasts.error.getWabaInformationTitle');
            const errortext = await this.$translate('detailsMessageTemplateSidebar.toasts.error.getWabaInformationText');
            this.BlipToastService.show('danger', {
                title: errorTitle,
                msg: errortext,
            });
        }
    }
    verifyButtonType() {
        try {
            const typeOnTranslation = this.data?.translations[0]?.buttons[0]?.type;
            if (typeOnTranslation === 'QUICK_REPLY') {
                this.buttonType = MessageTemplateButtonTypes.QUICK_REPLY;
            }
            else if (typeOnTranslation === 'PHONE_NUMBER' ||
                typeOnTranslation === 'URL') {
                this.buttonType = MessageTemplateButtonTypes.CALL_TO_ACTION;
            }
            else {
                this.buttonType = MessageTemplateButtonTypes.DEFAULT;
            }
        }
        catch (error) {
            console.error('Error determining button type:', error);
        }
    }
    isCarouselTemplate() {
        return this.data?.translations[0]?.type === 'carousel';
    }
    isPaymentTemplate(translation) {
        return translation?.buttons?.some(button => button.type === 'ORDER_DETAILS');
    }
    setSidebarHeight() {
        const windowHeight = window.innerHeight;
        const contentElement = document.getElementsByClassName('main-section')[0];
        const contentTop = contentElement.getBoundingClientRect().top;
        const header = document.getElementById('main-navbar');
        const headerBounding = header.getBoundingClientRect();
        const headerDown = headerBounding.height - headerBounding.bottom;
        const sidebar = document.getElementById('create-message-template-sidebar');
        const sidebarTop = contentTop >= 0 ? contentTop : 0;
        const sidebarHeight = contentTop <= 0
            ? '100%'
            : windowHeight - contentElement.offsetTop + headerDown + 'px';
        if (sidebar) {
            sidebar.setAttribute('style', `top: ${sidebarTop}px; height: ${sidebarHeight}`);
        }
    }
    closeSidebar() {
        this.close();
    }
    getTranslationName(language) {
        return this.$translate.instant(`messageTemplateLanguages.${language}`);
    }
    getStatusTranslate(status) {
        return this.$translate.instant(`detailsMessageTemplateSidebar.status.${status.toLocaleLowerCase()}`);
    }
    getRejectedReasonTranslate(rejectedReason) {
        switch (rejectedReason) {
            case MessageTemplateRejectedReasonStatus.Promotional:
                return this.$translate.instant('detailsMessageTemplateSidebar.reason.promotional');
            case MessageTemplateRejectedReasonStatus.InvalidFormat:
                return this.$translate.instant('detailsMessageTemplateSidebar.reason.invalidFormat');
            case MessageTemplateRejectedReasonStatus.IncorrectCategory:
                return this.$translate.instant('detailsMessageTemplateSidebar.reason.incorrectCategory');
            case MessageTemplateRejectedReasonStatus.Scam:
                return this.$translate.instant('detailsMessageTemplateSidebar.reason.scam');
            case MessageTemplateRejectedReasonStatus.AbusiveContent:
                return this.$translate.instant('detailsMessageTemplateSidebar.reason.abusiveContent');
            default:
                return this.$translate.instant('detailsMessageTemplateSidebar.reason.unknow');
        }
    }
    getBadgeColor(status) {
        switch (status) {
            case MessageTemplateStatus.Approved:
                return 'details-status__accepted';
            case MessageTemplateStatus.Pending:
                return 'details-status__pending';
            case MessageTemplateStatus.Rejected:
                return 'details-status__reject';
            default:
                return '';
        }
    }
    showReason(rejectedReason) {
        switch (rejectedReason) {
            case MessageTemplateRejectedReasonStatus.Promotional:
            case MessageTemplateRejectedReasonStatus.InvalidFormat:
            case MessageTemplateRejectedReasonStatus.IncorrectCategory:
            case MessageTemplateRejectedReasonStatus.Scam:
            case MessageTemplateRejectedReasonStatus.AbusiveContent:
                return true;
            default:
                return false;
        }
    }
    async copyToCliboard() {
        this.clipboard.copyText(this.data.namespace);
        const successMessage = await this.$translate('detailsMessageTemplateSidebar.toasts.success.copiedToClip');
        this.BlipToastService.show('success', {
            msg: successMessage,
        });
    }
    async confirmDeleteModal() {
        await this.AlertService.show({
            title: await this.$translate('detailsMessageTemplateSidebar.modal.confirmDeleteModal.title'),
            body: await this.$translate('detailsMessageTemplateSidebar.modal.confirmDeleteModal.text'),
            variant: 'delete',
            icon: 'trash',
            buttons: {
                cancel: await this.$translate('detailsMessageTemplateSidebar.modal.confirmDeleteModal.cancelButton'),
                confirm: await this.$translate('detailsMessageTemplateSidebar.modal.confirmDeleteModal.deleteButton'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => {
                    this.deleteMessageTemplate(this.data);
                },
            },
        });
    }
    async deleteMessageTemplate(messageTemplate) {
        try {
            this.LoadingService.startLoading();
            await Promise.all([
                this.MessageTemplateService.delete(messageTemplate.name),
                this.MessageTemplateSegmentService.trackTemplateDeleted({
                    MessageTemplateName: messageTemplate.name,
                    MessageTemplateCategory: messageTemplate.category,
                }),
            ]);
            const successMessage = await this.$translate('detailsMessageTemplateSidebar.toasts.success.saveDeleteSuccessText');
            await this.onDeleteMessageTemplate();
            this.BlipToastService.show('success', {
                msg: successMessage,
            });
            await this.closeSidebar();
        }
        catch (error) {
            const messageBase = await this.$translate('detailsMessageTemplateSidebar.toasts.error.saveDeleteErrorText');
            this.BlipToastService.show('danger', {
                title: messageBase,
                msg: error.description,
            });
        }
        // Finnaly removed to mantain the loading until all templates be loaded
    }
    async openDuplicateMessageSidebar() {
        if (this.isNewestMessageTemplateCategoriesEnabled &&
            !this.isNewCategory()) {
            await this.clearCategory();
        }
        await this.closeSidebar();
        await this.onDuplicateMessageTemplate();
    }
    clearCategory() {
        this.data.category = '';
        this.data.showCategory = '';
    }
    isNewCategory() {
        return ['AUTHENTICATION', 'UTILITY', 'MARKETING'].includes(this.data.category);
    }
}
DetailsMessageTemplateSidebarController.$inject = ['$document', 'close', '$scope', '$timeout', 'data', 'elementId', 'BlipToastService', '$translate', 'LoadingService', 'MessageTemplateService', 'MessageTemplateSegmentService', 'clipboard', 'onDeleteMessageTemplate', 'onDuplicateMessageTemplate', 'AlertService'];
